// Seed data: sponsors & well-wishers (Souvenir-style supporters).

export const seedSponsors = [
  {
    id: "seed-sp-1",
    name: "Ryan Group of Schools",
    business_name: "Ryan International Group",
    category: "Education",
    tier: "Platinum",
    description:
      '47 years of education excellence. "The Lord has done this, and it is marvellous in our eyes." – Psalm 118:23',
    logo_url: null,
    website: "https://www.ryangroup.org",
    phone: "+91 22 2600 1234",
    email: "info@ryangroup.org",
    souvenir_page: 6,
    is_featured: true,
    is_published: true,
    sort_order: 1,
  },
  {
    id: "seed-sp-2",
    name: "St. Xavier's High School & Jr. College",
    business_name: "St. Xavier's – Science & Commerce",
    category: "Education",
    tier: "Gold",
    description:
      "With best compliments from St. Xavier's High School & Jr. College of Science and Commerce.",
    logo_url: null,
    website: null,
    phone: "+91 22 2262 0661",
    email: null,
    souvenir_page: 8,
    is_featured: true,
    is_published: true,
    sort_order: 2,
  },
  {
    id: "seed-sp-3",
    name: "HDFC Bank — NRI Banking",
    business_name: "HDFC Bank Ltd.",
    category: "Banking & Finance",
    tier: "Platinum",
    description:
      "With best compliments from HDFC Bank — dedicated NRI banking services for the Catholic community.",
    logo_url: null,
    website: "https://www.hdfcbank.com",
    phone: "+91 22 6160 6161",
    email: null,
    souvenir_page: 31,
    is_featured: true,
    is_published: true,
    sort_order: 3,
  },
  {
    id: "seed-sp-4",
    name: "Model Co-operative Bank Ltd.",
    business_name: "Model Co-operative Bank",
    category: "Banking & Finance",
    tier: "Gold",
    description:
      "A multi-state scheduled co-operative bank serving the community since 1953.",
    logo_url: null,
    website: "https://www.modelbank.in",
    phone: "+91 22 2640 0589",
    email: "info@modelbank.in",
    souvenir_page: 42,
    is_featured: true,
    is_published: true,
    sort_order: 4,
  },
  {
    id: "seed-sp-5",
    name: "Our Lady of Lourdes Convent",
    business_name: "Lourdes Convent Trust",
    category: "Institutions",
    tier: "Best Compliments",
    description: "Best compliments and prayers for the mission of The Bombay Catholic Sabha.",
    logo_url: null,
    website: null,
    phone: null,
    email: null,
    souvenir_page: 11,
    is_featured: false,
    is_published: true,
    sort_order: 5,
  },
  {
    id: "seed-sp-6",
    name: "Thomas Hospitality Services",
    business_name: "Thomas Caterers & Events",
    category: "Hospitality",
    tier: "Silver",
    description:
      "Catering for weddings, parish feasts and community celebrations across Mumbai for three generations.",
    logo_url: null,
    website: null,
    phone: "+91 98200 12345",
    email: "bookings@thomashospitality.in",
    souvenir_page: 55,
    is_featured: false,
    is_published: true,
    sort_order: 6,
  },
  {
    id: "seed-sp-7",
    name: "KC Builders & Developers",
    business_name: "KC Realty Group",
    category: "Real Estate",
    tier: "Gold",
    description:
      "Redevelopment specialists for housing societies — transparent, timely and community-minded.",
    logo_url: null,
    website: null,
    phone: "+91 98211 22334",
    email: "sales@kcrealty.in",
    souvenir_page: 15,
    is_featured: false,
    is_published: true,
    sort_order: 7,
  },
  {
    id: "seed-sp-8",
    name: "The Sales Aces & Partners",
    business_name: "Sales Aces Consultancy",
    category: "Professional Services",
    tier: "Best Compliments",
    description: "With best wishes to the Sabha's service of the community.",
    logo_url: null,
    website: null,
    phone: null,
    email: null,
    souvenir_page: 68,
    is_featured: false,
    is_published: true,
    sort_order: 8,
  },
  {
    id: "seed-sp-9",
    name: "Holy Family Hospital",
    business_name: "Holy Family Hospital, Bandra",
    category: "Healthcare",
    tier: "Gold",
    description:
      "Compassionate, quality healthcare in the heart of Bandra — serving all communities since 1942.",
    logo_url: null,
    website: "https://www.holyfamilyhospitalbandra.com",
    phone: "+91 22 6267 0555",
    email: null,
    souvenir_page: 22,
    is_featured: true,
    is_published: true,
    sort_order: 9,
  },
  {
    id: "seed-sp-10",
    name: "Pereira & Sons Jewellers",
    business_name: "Pereira Jewellers",
    category: "Retail",
    tier: "Silver",
    description: "Trusted family jewellers — BIS hallmarked gold and certified diamonds.",
    logo_url: null,
    website: null,
    phone: "+91 98203 45678",
    email: null,
    souvenir_page: 47,
    is_featured: false,
    is_published: true,
    sort_order: 10,
  },
  {
    id: "seed-sp-11",
    name: "D'Souza Travel House",
    business_name: "DTH Tours & Pilgrimages",
    category: "Travel",
    tier: "Silver",
    description:
      "Pilgrimages to the Holy Land, Velankanni and Europe — group departures with spiritual directors.",
    logo_url: null,
    website: null,
    phone: "+91 99300 11223",
    email: "pilgrimages@dth.in",
    souvenir_page: 51,
    is_featured: false,
    is_published: true,
    sort_order: 11,
  },
  {
    id: "seed-sp-12",
    name: "Fernandes & Associates",
    business_name: "Fernandes Legal LLP",
    category: "Professional Services",
    tier: "Best Compliments",
    description: "Advocates & solicitors. With best compliments to The Bombay Catholic Sabha.",
    logo_url: null,
    website: null,
    phone: null,
    email: null,
    souvenir_page: 73,
    is_featured: false,
    is_published: true,
    sort_order: 12,
  },
];

export const sponsorCategories = [
  "All",
  "Banking & Finance",
  "Education",
  "Healthcare",
  "Real Estate",
  "Hospitality",
  "Travel",
  "Retail",
  "Professional Services",
  "Institutions",
];
